<template>
    <div
        class="shadow rounded-5px overflow-hidden cursor-pointer bg-white"
        @click="clickCampaign()"
        data-cy="btn_campaign_item_card"
    >
        <div
            class="campaign-image"
            :style="{ 'background-image': `url('${campaign.fullImageUrl}')` }"
            data-cy="container_campaign_item_image"
        >
            <template v-if="outOfStock">
                <div
                    class="absolute top-0 left-0 h-full w-full flex items-center justify-center bg-white bg-opacity-80"
                >
                    <div
                        class="text-dark-11 text-22 font-main-bold font-bold text-center"
                        v-html="lbl.privilage.outOfStock"
                        data-cy="text_campaign_item_out_of_stock"
                    ></div>
                </div>
            </template>
        </div>
        <div class="my-2 px-2">
            <div
                class="text-sm text-dark-2 line-clamp-2 break-all h-10 leading-snug"
                data-cy="text_campaign_item_name"
            >{{ campaign.name }}</div>
            <div
                class="text-11 text-dark-2 mt-2"
                data-cy="text_campaign_item_redeemable"
            >{{ FilterStringFormat(lbl.privilage.redeemable, FilterNumberFormat(campaign.qty)) }}</div>
        </div>
        <div class="rounded-b-5px">
            <button
                type="button"
                class="bg-gold text-dark-3 font-medium font-main-medium appearance-none outline-none bg-transparent h-10 text-sm w-full"
                data-cy="btn_campaign_item_action"
            >{{ isTypeNews ? lbl.privilage.buttons.showDetail : lbl.privilage.buttons.redeenNow }}</button>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import { CampaignType } from "@/helper/StaticValue.js";

export default {
    name: "CampaignItem",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    inject: ["UserLevels"],
    computed: {
        outOfStock: function () {
            return this.campaign.qty == 0
        },
        isTypeNews: function () {
            return this.campaign.type == CampaignType.News
        }
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            var pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        },

        clickCampaign: function () {
            /**@type {import("@/helper/TrackingHelper").TrackingService} */
            const trackingService = this.tracking

            if (this.UserLevels.isPlatinum) {
                let action = "click_redeem_campaignlist_platinum"
                if (this.isTypeNews) {
                    action = "click_show_detail_campaignlist_platinum"
                }
                trackingService.campaign("campaignlist_platinum", action, this.campaign, null)
            } else {
                let action = "click_redeem_campaignlist_gold"
                if (this.isTypeNews) {
                    action = "click_show_detail_campaignlist_gold"
                }
                trackingService.campaign("campaignlist_gold", action, this.campaign, null)
            }
            this.$router.push('/campaign/' + this.campaign.id);
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/image.scss";
$max-w: 276px;
.campaign-image {
    @include boxRatio($ratio: 100%);
    max-height: $max-w;
    max-width: $max-w;
}
</style>
